import { render, staticRenderFns } from "./TeacherDataOverview.vue?vue&type=template&id=29063fad&scoped=true"
import script from "./TeacherDataOverview.vue?vue&type=script&lang=js"
export * from "./TeacherDataOverview.vue?vue&type=script&lang=js"
import style0 from "./TeacherDataOverview.vue?vue&type=style&index=0&id=29063fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29063fad",
  null
  
)

export default component.exports